import {
  BaseellaStatus,
  BaseellaStatusTransition,
  Response,
  apiAbortController,
  TransactionStatusLog,
} from '@ui/src';
import api from '../../api/api';

export const statusesTransactionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStatusesTransactionById: build.query<
      {
        data: {
          prev: BaseellaStatusTransition[];
          next: BaseellaStatusTransition[];
        };
      },
      { url: string; id: string; baseellaStatusFrom: string }
    >({
      query: (data) => ({
        url: `/v1/${data.url}/${data.id}/statuses?baseellaStatusFrom=${data.baseellaStatusFrom}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getTransactionLogs: build.query<
      Response<TransactionStatusLog>,
      {
        id: string;
        url: string;
      }
    >({
      query: (data) => ({
        url: `/v1/transactions-queue-items/${data.url}?transactionId=${data.id}&all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    changeTransactionStatus: build.mutation<
      any,
      {
        url: string;
        id: string;
        body: {
          baseellaStatusFrom: BaseellaStatus;
          baseellaStatusTo: BaseellaStatus;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/${data.url}/${data.id}/status`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetStatusesTransactionByIdQuery,
  useChangeTransactionStatusMutation,
  useLazyGetTransactionLogsQuery,
} = statusesTransactionsApi;

export const {
  endpoints: {
    getStatusesTransactionById,
    changeTransactionStatus,
    getTransactionLogs,
  },
} = statusesTransactionsApi;
